
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Client } from "@/types/client";

type FormData = Omit<Client, "id" | "created_at" | "updated_at" | "client_assignments">;

interface AdditionalInfoTabProps {
  formData: FormData;
  onFormChange: (data: Partial<FormData>) => void;
}

export const AdditionalInfoTab = ({ formData, onFormChange }: AdditionalInfoTabProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const field = e.target.id;
    
    // تحديث البيانات الإضافية في حقل additional_info كـ JSON
    const currentInfo = formData.additional_info ? JSON.parse(formData.additional_info) : {};
    const updatedInfo = { ...currentInfo, [field]: value };
    
    onFormChange({ additional_info: JSON.stringify(updatedInfo) });
  };

  const getFieldValue = (field: string) => {
    if (!formData.additional_info) return '';
    try {
      const info = JSON.parse(formData.additional_info);
      return info[field] || '';
    } catch {
      return '';
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">معلومات إضافية</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name_en_additional">الاسم بالإنجليزية</Label>
          <Input
            id="name_en_additional"
            value={getFieldValue('name_en_additional')}
            onChange={handleChange}
            placeholder="Full Name in English"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="email">البريد الإلكتروني</Label>
          <Input
            id="email"
            type="email"
            value={getFieldValue('email')}
            onChange={handleChange}
            placeholder="email@example.com"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="mobile_second">الموبايل الثاني</Label>
          <Input
            id="mobile_second"
            value={getFieldValue('mobile_second')}
            onChange={handleChange}
            placeholder="+966xxxxxxxxx"
            type="tel"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="mobile_local">الموبايل المحلي</Label>
          <Input
            id="mobile_local"
            value={getFieldValue('mobile_local')}
            onChange={handleChange}
            placeholder="05xxxxxxxx"
            type="tel"
          />
        </div>

        <div className="space-y-2 md:col-span-2">
          <Label htmlFor="birth_date">تاريخ الميلاد</Label>
          <Input
            id="birth_date"
            type="date"
            value={getFieldValue('birth_date')}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};
